import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./main.component";
import { AuthGuardMain } from "../auth/auth-guard.service";
import { PermissionGuard } from "../guards/permisson.guard";

const routes: Routes = [
  {
    path: "main",
    component: MainComponent,
    canActivate: [AuthGuardMain],
    children: [
      { path: "", redirectTo: "/main/dashboard", pathMatch: "full" },
      {
        path: "dashboard",
        canActivate: [PermissionGuard],
        data: { level: "W", access: "dashboard" },
        loadChildren: () => import("./dashboard/dashboard.module").then((m) => m.DashboardModule)
      },
      {
        path: "analytic",
        loadChildren: () => import("./analytic/analytic.module").then((m) => m.AnalyticModule)
      },
      {
        path: "password",
        loadChildren: () => import("../main/password/password.module").then((m) => m.PasswordModule),
      },
      {
        path: "user-management",
        canActivate: [PermissionGuard],
        data: { level: "W", access: "users" },
        loadChildren: () =>
          import("../main/user-management/user-management.module").then((m) => m.UserManagementModule),
      },
      {
        path: "provider-earning-management",
        canActivate: [PermissionGuard],
        data: { level: "W", access: "users" },
        loadChildren: () =>
          import("../main/provider-earning-management/provider-earning-management.module").then((m) => m.ProviderEarningManagementModule),
      },
      {
        path: "roles",
        canActivate: [PermissionGuard],
        data: { level: "W", access: "roles" },
        loadChildren: () => import("../main/roles/roles.module").then((m) => m.RolesModule),
      },
      {
        path: "operator",
        canActivate: [PermissionGuard],
        data: { level: "W", access: "operators" },
        loadChildren: () => import("../main/operator/operator.module").then((m) => m.OperatorModule),
      },
      {
        path: "vehicle",
        canActivate: [PermissionGuard],
        data: { level: "W", access: "vehicles" },
        loadChildren: () => import("../main/vehicle/vehicle.module").then((m) => m.VehicleModule),
      },
      {
        path: "passenger",
        canActivate: [PermissionGuard],
        data: { level: "W", access: "passengers" },
        loadChildren: () => import("../main/passenger/passenger.module").then((m) => m.PassengerModule),
      },
      {
        path: "profile",
        canActivate: [PermissionGuard],
        data: { level: "W", access: "passengers" },
        loadChildren: () =>
          import("../main/profile-management/profile-management.module").then((m) => m.ProfileManagementModule),
      },
      {
        path: "category",
        canActivate: [PermissionGuard],
        data: { level: "W", access: "passengers" },
        loadChildren: () =>
          import("../main/category-management/category-management.module").then((m) => m.CategoryManagementModule),
      },
      {
        path: "payment-management",
        canActivate: [PermissionGuard],
        data: { level: "W", access: "invoice" },
        loadChildren: () =>
          import("../main/payment-management/payment-management.module").then((m) => m.PaymentManagementModule),
      },
      {
        path: "order",
        canActivate: [PermissionGuard],
        data: { level: "W", access: "invoice" },
        loadChildren: () =>
          import("../main/order-management/order-management.module").then((m) => m.OrderManagementModule),
      },
      {
        path: "fare",
        canActivate: [PermissionGuard],
        data: { level: "W", access: "invoice" },
        loadChildren: () =>
          import("../main/fare-management/fare-management.module").then((m) => m.FareManagementModule),
      },
      {
        path: "promo",

        loadChildren: () =>
          import("../main/promo-management/promo-management.module").then((m) => m.PromoManagementModule),
      },
      {
        path: "affiliate",
        canActivate: [PermissionGuard],
        data: { role: 'affiliate', level: "W", access: "affiliates" },
        loadChildren: () =>
          import("../main/affiliate-management/affiliate-management.module").then((m) => m.AffiliateManagementModule),
      },
      {
        path: "booking-management",

        loadChildren: () =>
          import("../main/booking-management/booking-management.module").then((m) => m.BookingManagementModule),
      },
      {
        path: "banner",
        canActivate: [PermissionGuard],
        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/banner-management/banner-management.module").then((m) => m.BannerManagementModule),
      },
      {
        path: "pickdrop",
        canActivate: [PermissionGuard],
        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/pickdrop-management/pickdrop-management.module").then((m) => m.PickdropManagementModule),
      },
      {
        path: "menu",
        canActivate: [PermissionGuard],
        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/menu-management/merchant-management.module").then((m) => m.MenuManagementModule),
      },
      {
        path: "merchant",
        canActivate: [PermissionGuard],
        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/merchant-management/merchant-management.module").then((m) => m.MerchantManagementModule),
      },
      {
        path: "map",
        canActivate: [PermissionGuard],
        data: { access: "invoice" },
        loadChildren: () => import("../main/map-management/map-management.module").then((m) => m.MapManagementModule),
      },
      {
        path: "officer-management",
        canActivate: [PermissionGuard],
        data: { access: "EO" },
        loadChildren: () => import("../main/officer/officer.module").then((m) => m.OfficerModule),
      },

      {
        path: "provider-management",
        canActivate: [PermissionGuard],
        data: { access: "drivers" },
        loadChildren: () =>
          import("./provider-management/driver-management.module").then((m) => m.DriverManagementModule),
      },

      {
        path: "reports-management",
        canActivate: [PermissionGuard],
        data: { access: "EO" },
        loadChildren: () =>
          import("../main/report-management/report-management.module").then((m) => m.ReportManagementModule),
      },
      {
        path: "trips-management",
        canActivate: [PermissionGuard],
        data: { access: "trips" },
        loadChildren: () =>
          import("../main/trips-management/trips-management.module").then((m) => m.TripsManagementModule),
      },

      {
        path: "stakeholder",
        canActivate: [PermissionGuard],
        data: { access: "stakeholders" },
        loadChildren: () => import("../main/stack-holder/shareholder.module").then((m) => m.ShareholderModule),
      },
      {
        path: "bookings",
        loadChildren: () => import("../main/payout/payout.module").then((m) => m.PayoutModule),
      },
      {
        path: "guest-bookings",
        loadChildren: () => import("../main/guest-bookings/guest-bookings.module").then((m) => m.GuestBookingsModule),
      },
      {
        path: "provider-payout",
        loadChildren: () => import("../main/provider-payout/provider-payout.module").then((m) => m.ProviderModule),
      },
      {
        path: "booking-history",
        loadChildren: () => import("../main/history/history.module").then((m) => m.HistoryModule),
      },
      {
        path: "uzber-driver",
        loadChildren: () => import("../main/uzber-driver/uzber-driver.module").then((m) => m.UzberDriverModule),
      },

      {
        path: "service-area-management",

        loadChildren: () => import("../main/officer/officer.module").then((m) => m.OfficerModule),
      },
      {
        path: "covid",
        canActivate: [PermissionGuard],
        data: { access: "covidTracker" },
        loadChildren: () => import("../main/covid/covid.module").then((m) => m.CovidModule),
      },
      {
        path: "terminal-management",
        canActivate: [PermissionGuard],
        data: { access: "terminals" },
        loadChildren: () =>
          import("../main/terminal-management/terminal-management.module").then((m) => m.TerminalManagementModule),
      },
      {
        path: "setting",
        loadChildren: () =>
          import("../main/setting-management/setting-management.module").then((m) => m.SettingManagementModule),
      },
      {
        path: "restrict-date",
        loadChildren: () => import("../main/restrict-holiday/restrict-holiday.module").then((m) => m.RestrictModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule { }
